import text from './FormAppendInput.vue'
const FormAppendInput = {
  install: function (Vue) {
    Vue.component('FormAppendInput', text)
  }
}
export default FormAppendInput
